import React, { Component } from "react";
import { Card } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { articledata, articlecolumns, defaultSorted } from "./TableInformation";

import "./_datatable.scss";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

class DataTableRemote extends Component {
  constructor() {
    super();
  }

  render() {
    console.log("Table Props", this.props);

    const customTotal = (from, to, size) => (
      <span className="ml-2 react-bootstrap-table-pagination-total">
        Showing {from} to {to} of {size} Results
      </span>
    );
    const options = {
      paginationSize: 4,
      pageStartIndex: 1,
      withFirstAndLast: false,
      firstPageText: "First",
      prePageText: "Previous",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      paginationTotalRenderer: customTotal,
      ...(this.props.remote && {
        page: Number(this.props.page) || 1,
        sizePerPage: Number(this.props.limit) || 10,
        totalSize: Number(this.props.totalCount) || 0,
        onPageChange: (page, sizePerPage) => {
          if (this.props.onPageChange) {
            this.props.onPageChange(page, sizePerPage);
          }
        },
        onSizePerPageChange: (sizePerPage, page) => {
          if (this.props.onPageChange) {
            this.props.onPageChange(page, sizePerPage);
          }
        },
      }),
      sizePerPageList: [
        {
          text: "10",
          value: 10
        },
        {
          text: "25",
          value: 25
        },
        {
          text: "50",
          value: 50
        },
        {
          text: "All",
          value: this.props.remote ? this.props.totalCount : this.props.parentData.length
        }
      ]
    };

    return (
      <ToolkitProvider
        keyField="id"
        data={this.props.parentData}
        columns={this.props.particlecolumns}
        defaultSorted={this.props.defaultSorted}
        bootstrap4
      >
        {toolkitprops => {
          console.log("Table", toolkitprops);

          return (
            <Card className="border-0 shadow-sm mb-4">
              <Card.Header className="bg-white">
                <Card.Title className="mb-0">{this.props.name}</Card.Title>
              </Card.Header>
              <Card.Body>
                <div className="position-relative">
                  {this.props.isPageLoading && (
                    <div
                      className="position-absolute w-100 h-100"
                      style={{
                        background: "rgba(255, 255, 255, 0.92)",
                        zIndex: 10,
                        top: 0,
                        left: 0,
                        padding: "8px 4px",
                        overflow: "hidden",
                      }}
                    >
                      <style>{`@keyframes dtrShimmer { 0% { background-position: -700px 0; } 100% { background-position: 700px 0; } } .dtr-shim { background: linear-gradient(90deg, #eef1f5 25%, #e2e6ec 50%, #eef1f5 75%); background-size: 700px 100%; animation: dtrShimmer 1.3s infinite linear; border-radius: 6px; }`}</style>
                      {Array.from({ length: Math.min(Number(this.props.limit) || 10, 8) }).map((_, r) => (
                        <div key={r} style={{ display: "flex", gap: 16, padding: "12px 8px", borderBottom: "1px solid #f3f4f6", alignItems: "center" }}>
                          {(this.props.particlecolumns || []).map((_, c) => (
                            <div key={c} className="dtr-shim" style={{ height: 12, flex: 1 }} />
                          ))}
                        </div>
                      ))}
                    </div>
                  )}
                  <BootstrapTable
                    remote={this.props.remote}
                    onTableChange={this.props.onTableChange}
                    defaultSorted={this.props.defaultSorted}
                    bordered={false}
                    wrapperClasses="table-responsive"
                    {...toolkitprops.baseProps}
                    pagination={paginationFactory(options)}
                  />
                </div>
              </Card.Body>
            </Card>
          );
        }}
      </ToolkitProvider>
    );
  }
}

export default DataTableRemote;
